import {observable} from "mobx";
import CargoService from "../../../services/CargoService";
import {arrayToString, stringToArray} from "../../../utils/formatar";
import ParametroGeralService from "../../../services/ParametroGeralService";

export default class ParametrosGeraisStore {
    @observable modoEdicao;
    @observable parametros;
    @observable idCargosSelecionados;
    @observable cargos;
    @observable salvando;

    constructor(loadingPanelStore, validacaoStore, formStore) {
        this.loadingPanelStore = loadingPanelStore;
        this.validacaoStore = validacaoStore;
        this.formStore = formStore;
        this.modoEdicao = false;
        this.resetParametrosGerais();
        this.cargoService = new CargoService();
        this.parametrosSalvos = this.parametros;
        this.parametroGeralService = new ParametroGeralService();
        this.salvando = false;
    }

    editar() {
        this.parametrosSalvos = Object.assign({}, this.parametros);
        this.idCargosSelecionados = arrayToString(this.parametros.qrtCargosNaoConsiderados, "id", true);
        this.parametrosSalvos.qrtCargosNaoConsiderados = this.parametros.qrtCargosNaoConsiderados ? this.parametros.qrtCargosNaoConsiderados.slice(0) : [];
        this.toggleModoEdicao();
    }

    reverter() {
        this.parametros = this.parametrosSalvos;
        this.idCargosSelecionados = arrayToString(this.parametros.qrtCargosNaoConsiderados, "id", true)
        this.toggleModoEdicao();
    }

    salvar() {
        this.formStore.setSubmitted(true);
        if (this.validacaoStore.isValidForm) {
            this.salvando = true;
            this.parametroGeralService.save(this.parametros).then(response => {
                this.parametros = response.data;
                this.toggleModoEdicao();
                this.salvando = false;
            }).catch(error => {
                console.log(error)
                this.salvando = false;
            })
        }
    }

    toggleModoEdicao() {
        this.modoEdicao = !this.modoEdicao;
    }

    setCrQntContratoSucessivo(value) {
        this.parametros.crQntContratoSucessivo = value;
    }

    setCrPeriodoAnalise(value) {
        this.parametros.crPeriodoAnalise = value;
    }

    setCrPrctAlocacaoMinIntervalo(value) {
        this.parametros.crPrctAlocacaoMinIntervalo = value;
    }

    setFdcPeriodoAnalise(value) {
        this.parametros.fdcPeriodoAnalise = value;
    }

    setQrtParaContratosRecorrentes(value) {
        this.parametros.qrtParaContratosRecorrentes = value;
    }

    setQrtParaFmtDiferenteContratacao(value) {
        this.parametros.qrtParaFmtDiferenteContratacao = value;
    }

    setQrtParaExMot(value) {
        this.parametros.qrtParaExMot = value;
    }

    setQrtParaExPsp(value) {
        this.parametros.qrtParaExPsp = value;
    }

    setQrtParaExFuncionario(value) {
        this.parametros.qrtParaExFuncionario = value;
    }

    setQrtParaExTerceiro(value) {
        this.parametros.qrtParaExTerceiro = value;
    }

    setQrtCargosNaoConsideradosIds(value) {
        this.parametros.qrtCargosNaoConsiderados = stringToArray(this.cargos, value, "id");
        this.idCargosSelecionados = value;
    }

    setSlaEttTempReinv(value){
        this.parametros.slaEttTmpReinv = value;
    }

    setSlaEttTmpEnvioAposReinv(value) {
        this.parametros.slaEttTmpEnvioAposReinv = value;
    }

    setSlaEttTmpRespProrrogacao(value) {
        this.parametros.slaEttTmpRespProrrogacao = value;
    }

    setSlaEttTmpRespSubstituicao(value) {
        this.parametros.slaEttTmpRespSubstituicao = value;
    }

    setSlaEttTmpRespTA(value) {
        this.parametros.slaEttTmpRespTA = value;
    }

    setSlaEttTmpEnvioLH(value) {
        this.parametros.slaEttTmpEnvioLH = value;
    }

    setSlaEttTmpEnvioDadosNF(value) {
        this.parametros.slaEttTmpEnvioDadosNF = value;
    }

    setSlaGslTmpAvaliarResponder(value) {
        this.parametros.slaGslTmpAvaliarResponder = value;
    }

    setSlaNgfTmpAvaliarResponder(value) {
        this.parametros.slaNgfTmpAvaliarResponder = value;
    }

    setSlaDirTmpAvaliarResponder(value) {
        this.parametros.slaDirTmpAvaliarResponder = value;
    }

    setSlaGrlTmpAvaliarResponder(value) {
        this.parametros.slaGrlTmpAvaliarResponder = value;
    }

    setSlaSlcTmpRespAjustDemand(value) {
        this.parametros.slaSlcTmpRespAjustDemand = value;
    }

    setSlaTmpOutrosResponder(value){
        this.parametros.slaOutrosTmpResponder = value;
    }

    setSmrsgPrctPraticado(value) {
        this.parametros.smrsgPrctPraticado = value;
    }

    setSmrsgPrctMin(value) {
        this.parametros.smrsgPrctMin = value;
    }

    setSmrsgPrctRgl(value) {
        this.parametros.smrsgPrctRgl = value;
    }

    setSmrsgPrctMinAvalGestor(value) {
        this.parametros.smrsgPrctMinAvalGestor = value;
    }

    setSmrsgPrctMinAvalAR(value) {
        this.parametros.smrsgPrctMinAvalAR = value;
    }

    setPmrifSolicitacaoMin(value) {
        this.parametros.pmrifSolicitacaoMin = value;
    }

    setPmrifSolicitacaoRgl(value) {
        this.parametros.pmrifSolicitacaoRgl = value;
    }

    setPmrifProrrogUmMin(value) {
        this.parametros.pmrifProrrogUmMin = value;
    }

    setPmrifProrrogUmRgl(value) {
        this.parametros.pmrifProrrogUmRgl = value;
    }

    setPmrifProrrogDoisMin(value) {
        this.parametros.pmrifProrrogDoisMin = value;
    }

    setPmrifProrrogDoisRgl(value) {
        this.parametros.pmrifProrrogDoisRgl = value;
    }

    setPmrifProrrogTresMin(value) {
        this.parametros.pmrifProrrogTresMin = value;
    }

    setPmrifProrrogTresRgl(value) {
        this.parametros.pmrifProrrogTresRgl = value;
    }

    setPmraifProrrogUmMin(value) {
        this.parametros.pmraifProrrogUmMin = value;
    }

    setPmraifProrrogUmRgl(value) {
        this.parametros.pmraifProrrogUmRgl = value;
    }

    setPgmDiaIncPeriodoApuracao(value) {
        this.parametros.pgmDiaIncPeriodoApuracao = value;
    }

    setPgmDiaGerControlePonto(value) {
        this.parametros.pgmDiaGerControlePonto = value;
    }

    setPgmDiaGerLotePagamento(value) {
        this.parametros.pgmDiaGerLotePagamento = value;
    }


    setConta_rc(value) {
        this.parametros.conta_rc = value;
    }

    setEmailCriacaoLP(value) {
        this.parametros.emailCriacaoLP = value;
    }

    setEmailSolicitacaoCracha(value) {
        this.parametros.emailSolicitacaoCracha = value;
    }

    setItemContratoRc(value) {
        this.parametros.itemContratoRc = value;
    }

    carregarDados() {
        this.loadingPanelStore.setIsLoading("parametrosGeraisLoading", true);
        const dadosPromise = Promise.all([
            this.carregarLista(),
            this.carregarCargos()
        ]);

        dadosPromise.then(() => {
            this.loadingPanelStore.setIsLoading("parametrosGeraisLoading", false);
        }).catch(error => {
            this.loadingPanelStore.setIsLoading("parametrosGeraisLoading", false);
            console.log(error);
        });
    }

    carregarLista() {
        return this.parametroGeralService.list().then(response => {
            this.parametros = response.data;
            this.idCargosSelecionados = arrayToString(this.parametros.qrtCargosNaoConsiderados, "id", true);
        })
    }

    carregarCargos(){
        return this.cargoService.listFromBase().then(response => {
            let cargosLista = response.data.filter(cargo => cargo)
            .map(cargo => ({
                id: cargo.id,
                nome: cargo.nome + " (" + cargo.id + ")"
            })); 
            this.cargos = cargosLista;
        })
    }

    resetParametrosGerais() {
        this.parametros = {
            crQntContratoSucessivo: 4,
            crPeriodoAnalise: 720,
            crPrctAlocacaoMinIntervalo: 50,
            fdcPeriodoAnalise: 720,
            qrtParaContratosRecorrentes: 540,
            qrtParaFmtDiferenteContratacao: 540,
            qrtParaExMot: 90,
            qrtParaExPsp: 90,
            qrtParaExFuncionario: 90,
            qrtParaExTerceiro: 90,
            qrtCargosNaoConsideradosIds: "",
            qrtCargosNaoConsiderados: [],
            slaEttTmpReinv:2,
            slaEttTmpEnvioAposReinv: 2,
            slaEttTmpRespProrrogacao: 2,
            slaEttTmpRespSubstituicao: 2,
            slaEttTmpRespTA: 2,
            slaEttTmpEnvioLH: 2,
            slaEttTmpEnvioDadosNF: 2,
            slaSlcTmpRespAjustDemand: 2,
            slaGslTmpAvaliarResponder: 2,
            slaNgfTmpAvaliarResponder: 2,
            slaDirTmpAvaliarResponder: 2,
            slaGrlTmpAvaliarResponder: 1,
            slaOutrosTmpResponder:2,
            smrsgPrctPraticado: 80,
            smrsgPrctMin: 80,
            smrsgPrctRgl: 120,
            smrsgPrctMinAvalGestor: 80,
            smrsgPrctMinAvalAR: 100,
            pmrifSolicitacaoMin: 3,
            pmrifSolicitacaoRgl: 10,
            pmrifProrrogUmMin: 3,
            pmrifProrrogUmRgl: 10,
            pmrifProrrogDoisMin: 3,
            pmrifProrrogDoisRgl: 10,
            pmrifProrrogTresMin: 3,
            pmrifProrrogTresRgl: 10,
            pmraifProrrogUmMin: 3,
            pmraifProrrogUmRgl: 10,
            pgmDiaIncPeriodoApuracao: 1,
            pgmDiaGerControlePonto: 1,
            pgmDiaGerLotePagamento: 10,
            conta_rc: 5432,
            emailCriacaoLP : "",
            itemContratoRc: "",
            emailSolicitacaoCracha : "",
            execIniciarFluxos: 0
        }
    }
    //RHFPP-1447-automatizacao-timesheets
    iniciarFluxosEmExecucao(){
        return (this.parametros.execIniciarFluxos && this.parametros.execIniciarFluxos == 1);
    }
}